import ReceiverStore from './ReceiverStore';

export default {
  receiverStore: new ReceiverStore(),
};
